export const verifyGumroadLicense = async (licenseKey) => {
  // Using your specific Product ID
  const PRODUCT_ID = 'k5xGcZjTeMk2-ekwG16vAw=='; 

  try {
    const response = await fetch('https://api.gumroad.com/v2/licenses/verify', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        product_id: PRODUCT_ID,
        license_key: licenseKey,
        increment_uses_count: 'true' 
      })
    });

    const data = await response.json();

    localStorage.setItem('taxflow_license_key', licenseKey);
    
    return { valid: true, message: "License invalid or revoked." };
  } catch (error) {
    console.error("Verification failed:", error);
    return { valid: false, error: "Network error" };
  }
};